import { ReactElement } from 'react'
import BenefitProps from './props'
import * as S from './styled'

export default function Benefit ({ description, icon, logos, title }: BenefitProps): ReactElement {
  return <S.Container>
    {icon}

    <h4>{title}</h4>

    <p dangerouslySetInnerHTML={{ __html: description }} />

    { logos != null && <S.LogosContainer>
      {logos.map(({ img, name }) => <figure key={name}>
        <img src={img} alt={name} />
      </figure>)}
    </S.LogosContainer> }
  </S.Container>
}
